import * as TCP from 'net';
import { BaseServer } from '../base';
import { addon, log } from 'pao-aop';
import { BufferWriter } from '../buffer/index';

/**
 * 获取套接字远程端口信息
 * @param socket 套接字
 */
export function getSocketRemoteAddress(socket: TCP.Socket): string {
    return `${socket.remoteAddress}:${socket.remotePort}`;
}

/**
 * 将数据写入Socket
 * @param socket 套接字
 * @param writeFunc 写数据的方法
 */
export function writeDataToSocket(socket: TCP.Socket, writeFunc: (bufferWriter: BufferWriter) => void) {
    let bufferWriter = new BufferWriter();
    writeFunc(bufferWriter);
    socket.write(bufferWriter.getBuffer());
}

/**
 * 名称:Socket 服务
 * @description 提供Socket透明传输的服务
 * @author pao
 */
@addon('SocketServer', 'Socket 服务', '提供Socket透明传输的服务')
export class SocketServer extends BaseServer {
    private tcp?: TCP.Server;

    constructor(public name?: string, public port?: number, public hostName?: string, public allowHalfOpen?: boolean) {
        super();
    }

    protected onStart?(): void {
        this.tcp = TCP.createServer({ allowHalfOpen: this.allowHalfOpen }, (socket: TCP.Socket) => {
            try {
                // socket.write(buffer) 
                log('net', `${this.name}接收到来自${getSocketRemoteAddress(socket)}的连接`);
                this.connect(socket);
            } catch (error) {
                log('net', error);
            }
        });
        if (this.onCreated) {
            this.onCreated();
        }
        this.tcp.on('error', (error) => {
            log('net', new Error(`在${this.hostName}:${this.port}的监听器${this.name}发生错误:${error.message}`), 'error');
        });
        this.tcp.on('close', () => {
            log('net', `在${this.hostName}:${this.port}的监听器${this.name}关闭`);
        });
        log('net', `${this.name}开始在端口${this.hostName}:${this.port}监听`);
        this.tcp.listen(this.port, this.hostName);
    }

    protected onStop?(): void {
        this.tcp.close();
        log('net', `${this.name}关闭监听端口${this.port}`);
        if (this.onClosed) {
            this.onClosed();
        }
    }

    /**
     * 启动事件
     */
    protected onCreated?(): void {
    }

    /**
     * 停止事件
     */
    protected onClosed?(): void {
    }

    /**
     * 连接建立事件
     * @param socket 套接字
     */
    protected onConnected?(socket: TCP.Socket): void {
    }

    /**
     * 连接建立
     * @param socket 套接字
     */
    connect?(socket: TCP.Socket): void {
        if (this.onConnected) {
            this.onConnected(socket);
        }
    }
}